import * as actions from "./actions";
import { Auth } from "aws-amplify";
import { http, v1http } from "../utils";
import { resolve } from "dns";

export function login(dispatch: any) {
	return function (values: any) {
		dispatch(actions.loginStart());
		return Auth.signIn(values.username, values.password)
			.then((r) => {
				dispatch(actions.loginSuccess(r));
			})
			.catch((err) => {
				if (err.code === "UserNotConfirmedException") {
					dispatch(resendConfirmationCode(values.username));
					dispatch(actions.showConfirmEmail(values.username));
				} else {
					dispatch(actions.loginError(err));
				}
			});
	};
}

export function logout(dispatch: any) {
	return async function (user: any) {
		return new Promise((resolve) => {
			Auth.signOut().then((r) => {
				dispatch(actions.logout());
				resolve(true);
			});
		});
	};
}

export function signUp(dispatch: any) {
	return async (values: any) => {
		// dispatch(actions.registerStart())
		return await Auth.signUp(values)
			.then((r: any) => {
				dispatch(actions.registerSuccess(r.user));
				return r;
			})
			.catch((error: any) => {
				if (error.code !== "UsernameExistsException") {
					dispatch(actions.registerError(error));
				}
				return error;
			});
	};
}

export function resendConfirmationCode(values: any) {
	return async (dispatch: any) => {
		const result = await Auth.resendSignUp(values);
	};
}

export function confirmSignUp(dispatch: any) {
	return (data: any) => {
		return Auth.confirmSignUp(data.Username, data.ConfirmationCode)
			.then((confirmation) => {
				dispatch(actions.confirmRegisterSuccess(confirmation));
			})
			.catch((err) => console.error(err));
	};
}

export function storeSession(dispatch: any) {
	return async (session: any) => {
		dispatch(actions.storeSession(session));
	};
}

export function setUser(dispatch: any) {
	return (user: any) => {
		dispatch(actions.setUser(user));
	};
}

export function resetPasswordRequest(dispatch: any) {
	return async (email: any) => {
		dispatch(actions.resetPasswordRequestStart());

		return Auth.forgotPassword(email)
			.then((data) => {
				dispatch(actions.resetPasswordRequestSuccess(data));
			})
			.catch((err) => dispatch(actions.resetPasswordRequestError(err)));
	};
}

export function resetPassword(dispatch: any) {
	return async (payload: any) => {
		dispatch(actions.resetPasswordStart());
		return Auth.forgotPasswordSubmit(payload.email, payload.code, payload.password)
			.then((data) => {
				dispatch(actions.resetPasswordSuccess(data));
				return data;
			})
			.catch((err) => {
				console.error(err);
				dispatch(actions.resetPasswordError(err));
				return err;
			});
	};
}

export function registerIssuer(dispatch: any) {
	dispatch(actions.registerIssuerStart());
	return (issuer: any) => {
		return http
			.post(`issuers`, issuer)
			.then((r) => {
				dispatch(actions.registerIssuerSuccess(r));
				return issuer;
			})
			.catch((err) => {
				console.error(err);
				dispatch(actions.registerIssuerError(err));
				return err;
			});
	};
}

export function getIssuer(dispatch: any) {
	return (email: any) => {
		dispatch(actions.getIssuerStart());
		return v1http
			.get(`issuers/${email}`)
			.then((data) => {
				dispatch(actions.getIssuerSuccess(data.data.issuer));
				return data;
			})
			.catch((err) => {
				console.error(err);
				dispatch(actions.getIssuerError(err));
				return err;
			});
	};
}

export function updateIssuer(dispatch: any) {
	dispatch(actions.updateIssuerStart());
	return (issuer: any) => {
		return http
			.put(`issuers`, issuer)
			.then((r: any) => {
				dispatch(actions.updateIssuerSuccess(r.data.issuer));
				return r;
			})
			.catch((err) => {
				console.error(err);
				dispatch(actions.updateIssuerError(err));
				return err;
			});
	};
}

// This endpoint needs to be tested
export function deleteIssuer(dispatch: any) {
	dispatch(actions.registerIssuerStart());
	return (issuer: any) => {
		return http
			.delete(`issuers/${issuer}`)
			.then((data: any) => {
				dispatch(actions.deleteIssuerSuccess());
				return data;
			})
			.catch((err) => {
				console.error(err);
				dispatch(actions.deleteIssuerError(err));
				return err;
			});
	};
}
